/**
 * Created by beyondin on 2018/7/27.
 */
import aboutUs from '@/view/aboutUs/index'
import aboutUsBranch from '@/view/aboutUs/branch'
import contactUs from '@/view/aboutUs/contactUs'
import contactHonor from '@/view/aboutUs/honor'
const route = [{
    path: '/aboutUs'+'/:aboutId'+'.html',
    meta: {
      title: '关于我们'
    },
    component: aboutUs
  },{
    path: '/aboutHonor'+'/:aboutId'+'.html',
    meta: {
      title: '企业荣誉'
    },
    component: contactHonor
  },{
    path: '/aboutBranch'+'/:aboutId'+'.html',
    meta: {
      title: '分院介绍'
    },
    component: aboutUsBranch
  },
  {
    path: '/aboutContactUs'+'/:aboutId'+'.html',
    meta: {
      title: '联系我们'
    },
    component: contactUs
  }
];

export default route;



// WEBPACK FOOTER //
// ./src/router/aboutUs.js